export class ScrollToTop {
    domElement

    constructor() {
        this.domElement = document.querySelector('.js-scroll-to-top')
        if (this.domElement) {
            this.initializeScrollToTop()
        }
    }

    initializeScrollToTop() {
        this.domElement.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
            })
        })
    }
}
